(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-with-image"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq-item");

  faqItems.forEach((item) => {
    const question = item.querySelector(".faq-question");
    const answer = item.querySelector(".faq-answer");
    const icon = question.querySelector(".faq-icon");

    question.addEventListener("click", function () {
      const isActive = item.classList.contains("active");

      // Close all FAQs first
      faqItems.forEach((faq) => {
        faq.classList.remove("active");
        faq.querySelector(".faq-answer").style.maxHeight = null;
        faq.querySelector(".faq-icon").textContent = "▼";
      });

      // Toggle the clicked FAQ
      if (!isActive) {
        item.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
        icon.textContent = "▲";
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();
})();
